import { render, staticRenderFns } from "./CompanyClassification.vue?vue&type=template&id=613224ae"
import script from "./CompanyClassification.vue?vue&type=script&lang=js"
export * from "./CompanyClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports